import { useState, useEffect, useRef, useCallback } from 'react';

export default function useProjectsTips() {
  const [showTips, setShowTips] = useState(false);
  const timerRef = useRef(null);

  const dismiss = useCallback(() => {
    clearTimeout(timerRef.current);
    setShowTips(false);
  }, []);

  const trigger = useCallback(() => {
    clearTimeout(timerRef.current);
    setShowTips(true);
    timerRef.current = setTimeout(() => setShowTips(false), 6000);
  }, []);

  useEffect(() => {
    const el = document.getElementById('projects');
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          trigger();
          observer.disconnect();
        }
      },
      { threshold: 0, rootMargin: '-80px 0px -300px 0px' }
    );
    observer.observe(el);

    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#projects') {
        setTimeout(() => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight - 100 && rect.bottom > 100) {
            trigger();
            observer.disconnect();
          }
        }, 400);
      } else {
        dismiss();
      }
    });

    return () => {
      observer.disconnect();
      clearTimeout(timerRef.current);
    };
  }, [trigger, dismiss]);
 
  return { showTips, trigger, dismiss };
}
